import MainPage from "../../components/catalog/mainPage";

const Catalog = ({ authUser }) => {
  return (
    <>
      <MainPage authUser={authUser} />
    </>
  );
};
export default Catalog;
